import { Center, Stack, ThemeIcon, Text } from '@mantine/core';
import { IconInbox, type Icon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface EmptyStateProps {
  icon?: Icon;
  title?: string;
  description?: string;
  action?: React.ReactNode;
  height?: number | string;
}

export function EmptyState({ icon: IconCmp = IconInbox, title, description, action, height = 220 }: EmptyStateProps) {
  const { t } = useTranslation();
  return (
    <Center h={height}>
      <Stack align="center" gap="xs">
        <ThemeIcon size={56} radius="xl" variant="light" color="gray">
          <IconCmp size={28} stroke={1.6} />
        </ThemeIcon>
        <Text fw={600}>{title ?? t('common.noData')}</Text>
        {description && <Text c="dimmed" size="sm" ta="center" maw={340}>{description}</Text>}
        {action}
      </Stack>
    </Center>
  );
}
